<div class="row mb-md-2 justify-content-center">
    <div class="col-lg-2 mb-1 mb-md-0">
        <button type="button" class="btn w-100 nav-btn btn-outline-primary" (click)="emitNav('socialsignal')" rippleEffect>
            <span [data-feather]="'clipboard'" [class]="'mr-25'"></span>Social Signal
        </button>
    </div>
    <div class="col-lg-2 mb-1 mb-md-0">
        <button type="button" class="btn w-100 nav-btn btn-outline-primary" (click)="emitNav('technical')" rippleEffect>
            <span [data-feather]="'trending-up'" [class]="'mr-25'"></span>Technical
        </button>
    </div>
    <div class="col-lg-2 mb-1 mb-md-0">
        <button type="button" class="btn w-100 nav-btn btn-outline-primary" (click)="emitNav('alternatives')" rippleEffect>
            <span [data-feather]="'eye'" [class]="'mr-25'"></span>Fundamental
        </button>
    </div>
    <div class="col-lg-2 mb-1 mb-md-0">
        <button type="button" class="btn w-100 nav-btn btn-outline-primary" (click)="emitNav('valuation')" rippleEffect>
            <span [data-feather]="'box'" [class]="'mr-25'"></span>Valuation
        </button>
    </div>
    <div class="col-lg-2 mb-1 mb-md-0">
        <button type="button" class="btn w-100 nav-btn btn-outline-primary" (click)="emitNav('news')" rippleEffect>
            <span [data-feather]="'message-circle'" [class]="'mr-25'"></span>Social News
        </button>
    </div>
</div>